import React, { useEffect, useState } from "react";
import Search from "components/Search/Search";
import { Box, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { searchFormSelector } from "redux/searchForm";
import { updateSearchQuery, searchQuerySelector } from "redux/searchQuery";
import { isDiff, deepCloneObject } from "@thekilroygroup/shared-ui";

interface IProps {
  desktopHeaderRef: any;
  triggerFetch: () => void;
}
export const DesktopSearchHeader = (props: IProps) => {
  const searchForm = useSelector(searchFormSelector);
  const searchQuery = useSelector(searchQuerySelector);
  const { desktopHeaderRef, triggerFetch = () => {} } = props;
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();
  useEffect(() => {
    const desktopHeaderElement = desktopHeaderRef.current;
    setExpanded(true);
    if (
      desktopHeaderElement !== undefined &&
      searchForm.tripType === "MULTI_DEST"
    ) {
      desktopHeaderElement.addEventListener("mouseenter", handleEnter, true);
      desktopHeaderElement.addEventListener("mouseleave", handleLeave, true);
      setTimeout(() => {
        window.addEventListener("scroll", handleScroll, true);
      }, 500);
    } else if (searchForm.tripType !== "MULTI_DEST") {
      desktopHeaderElement.removeEventListener("mouseenter", handleEnter, true);
      desktopHeaderElement.removeEventListener("mouseleave", handleLeave, true);
      window.removeEventListener("scroll", handleScroll, true);
    }
  }, [searchForm.tripType, desktopHeaderRef]);

  const submitForm = (e: React.MouseEvent) => {
    if (!isDiff(searchForm, searchQuery)) {
      triggerFetch();
    } else {
      dispatch(updateSearchQuery(deepCloneObject(searchForm)));
      triggerFetch();
    }
  };

  const calcMaxHeight = () => {
    const tripAmount = searchForm.flights.length;
    return 154 + tripAmount * 104;
  };

  const handleEnter = (e: MouseEvent) => {
    window.removeEventListener("scroll", handleScroll, true);
    const desktopHeaderElement = desktopHeaderRef.current;
    desktopHeaderElement.removeEventListener("mouseenter", handleEnter, true);
    desktopHeaderElement.addEventListener("mouseleave", handleLeave, true);
    setExpanded(true);
  };

  const handleLeave = (e: MouseEvent) => {
    window.addEventListener("scroll", handleScroll, true);
    const desktopHeaderElement = desktopHeaderRef.current;
    desktopHeaderElement.removeEventListener("mouseleave", handleLeave, true);
  };

  const handleScroll = () => {
    window.removeEventListener("scroll", handleScroll, true);
    const desktopHeaderElement = desktopHeaderRef.current;
    desktopHeaderElement.addEventListener("mouseenter", handleEnter, true);
    setExpanded(false);
  };

  return (
    <Box
      sx={{
        pb: 2,
        overflow: "hidden",
        transition: `max-height ${theme.transitions.duration.enteringScreen}ms ${theme.transitions.easing.easeIn}`,
        maxHeight: expanded ? calcMaxHeight() : 160,
      }}
    >
      <Search variation="header" handleSubmit={submitForm} />
    </Box>
  );
};
